"use client";
import { useRouter } from "next/navigation";
import React from "react";
import { Button, Modal } from "react-bootstrap";

const GuestOrderModal = ({ show, onHide, setSignIn, setOrderModal, data }) => {
  const router = useRouter();

  return (
    //   Modal with two options SignIn or Continue as Guest
    //   If SignIn is clicked, user will be redirected to SignInModal component
    //   If Continue as Guest is clicked, user will be redirected to the order page with Guest user details

    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Continue to Checkout!</Modal.Title>
      </Modal.Header>

      <Modal.Body className="justify-content-center">
        <p>
          Are you already registered? Sign in to secure your order and enjoy
          exclusive discounts or you can just continue as a guest user.
        </p>
        <div className="row">
          <div className="col-6">
            <Button
              variant="secondary"
              onClick={() => {
                setSignIn(true);
                onHide();
              }}
              className="w-100"
            >
              Sign In
            </Button>
          </div>
          <div className="col-6">
            <Button
              className="w-100"
              variant="outline-primary"
              onClick={() => {
                router.push(
                  `/Orders/checkout?product_id=${data?.listing_id}`
                );
                onHide();
              }}
            >
              Continue as Guest
            </Button>
          </div>
        </div>
        {/* <div className="d-flex mx-2 align-items-center">OR</div> */}
      </Modal.Body>
    </Modal>
  );
};

export default GuestOrderModal;
